// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_js_compare_js":"2615b0edad605b548fa0","src_js_sameHeight_js":"e405feb19f6a4156367b"}[chunkId] + ".js";
};